// Storage keys used by LaunchDarkly Session Replay SDK and highlight.run
// These match the internal storage patterns used by the SDKs for session tracking
const LAUNCHDARKLY_STORAGE_KEYS = {
	SESSION_ID: 'sessionID',
	SESSION_DATA_PREFIX: 'sessionData_',
} as const;

// highlight.run persists these keys to correlate sessions across page loads.
// They must be cleared on user transitions to prevent session hijacking.
const HIGHLIGHT_STORAGE_KEYS = ['highlightClientID', 'highlightUserObject', 'highlightIdentifier'] as const;

/**
 * Clear LaunchDarkly and highlight.run localStorage keys (used on logout and user switches).
 * Prevents session hijacking where User B inherits User A's session identity.
 * Note: Does not clear impersonation info - that should only be cleared when starting a new impersonation.
 */
export function clearLaunchDarklyStorage(): void {
	const allKeys = Object.keys(localStorage);
	const ldKeys = allKeys.filter(
		key => key === LAUNCHDARKLY_STORAGE_KEYS.SESSION_ID || key.startsWith(LAUNCHDARKLY_STORAGE_KEYS.SESSION_DATA_PREFIX)
	);
	ldKeys.forEach(key => localStorage.removeItem(key));

	// Clear highlight.run's persistent session identity keys
	HIGHLIGHT_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
}
